import React from 'react';
import { formatCurrency } from '../../../../../../../../../CommonUtils/formatNumber';
import { Box } from '../../../../../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../../../../../CommonComponents/OPL/Text/Text';
import { Card } from '../../../../../../../../../CommonComponents/OPL/Card/Card';

interface Props {
  shortTerm: number;
  longTerm: number;
  total: number;
  title: string;
}

export const DesktopTotals = ({ shortTerm, longTerm, total, title }: Props) => {
  return (
    <Box mb="4">
      <Card hasBorder>
        <Box p="12" borderBottom="1px solid" borderColor="neutral.200">
          <Text fontSize="h6" fontWeight={600}>
            {title}
          </Text>
        </Box>
        <Box display="flex">
          <Box p="24" display="flex" flexDirection="column" flex={1}>
            <Text mb="4" variant="smallCaps">
              Total Short Term Gain Loss
            </Text>

            <Text variant="tabular" fontSize="h2" fontWeight={500}>
              {formatCurrency(shortTerm, { decimalPlaces: 2 })}
            </Text>
          </Box>

          <Box
            p="24"
            display="flex"
            flexDirection="column"
            flex={1}
            borderLeft="1px solid"
            borderRight="1px solid"
            borderColor="neutral.200"
          >
            <Text mb="4" variant="smallCaps">
              Total Long Term Gain Loss
            </Text>

            <Text variant="tabular" fontSize="h2" fontWeight={500}>
              {formatCurrency(longTerm, { decimalPlaces: 2 })}
            </Text>
          </Box>

          <Box p="24" display="flex" flexDirection="column" flex={1}>
            <Text mb="4" variant="smallCaps">
              Total Gain Loss
            </Text>

            <Text variant="tabular" fontSize="h2" fontWeight={500}>
              {formatCurrency(total, { decimalPlaces: 2 })}
            </Text>
          </Box>
        </Box>
      </Card>
    </Box>
  );
};
